// Избранное, кроме билетов: отели, места, экскурсии, природа, пакеты туров — снимок карточки (как позиция «Моего тура»).
// Хранится в браузере; раздел «Избранное» показывает их вместе с билетами, оттуда — «В мой тур» и ссылка.
import { bus } from './bus';
import { store } from './storage';
import { createStore, useStore } from './store';
import type { TripItem } from './types';

export interface SavedCard extends TripItem {
  /** ключ карточки: вид и id у источника (или название) — по нему звёздочка знает, сохранена ли карточка */
  key: string;
  /** подпись вида на карточке («Отель», «Экскурсия») */
  kindLabel?: string;
  savedAt: string;
}

const KEY = 'saved';
const MAX = 200;

const load = (): SavedCard[] => {
  const list = store.get<SavedCard[]>(KEY, []);
  return Array.isArray(list) ? list.filter((x) => x && typeof x.key === 'string' && typeof x.title === 'string' && typeof x.kind === 'string') : [];
};

export const savedCards = createStore<{ items: SavedCard[] }>({ items: load() });
export const useSavedCards = () => useStore(savedCards).items;
export const useIsSaved = (key: string): boolean => useStore(savedCards, (s) => s.items.some((x) => x.key === key));

function persist(items: SavedCard[]): void {
  store.set(KEY, items);
  savedCards.set({ items });
  bus.emit('saved:changed', items.length);
}

/** Сохранить или убрать карточку; ответ — сохранена ли она теперь */
export function toggleSaved(card: Omit<SavedCard, 'savedAt'>): boolean {
  const items = savedCards.get().items;
  if (items.some((x) => x.key === card.key)) { persist(items.filter((x) => x.key !== card.key)); return false; }
  persist([{ ...card, savedAt: new Date().toISOString() }, ...items].slice(0, MAX));
  return true;
}

export const removeSaved = (key: string): void => persist(savedCards.get().items.filter((x) => x.key !== key));

/** Счётчик для значка «Избранного» при старте */
export const syncSaved = (): void => bus.emit('saved:changed', savedCards.get().items.length);
